import { render, staticRenderFns } from "./DataAnalysisDashboardPage.vue?vue&type=template&id=4e674ace&scoped=true"
import script from "./DataAnalysisDashboardPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysisDashboardPage.vue?vue&type=style&index=0&id=4e674ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e674ace",
  null
  
)

export default component.exports